"use client";

import styled from "styled-components";

export const FormGroup = styled.div`
  margin-bottom: 15px;
  display: block;
  width: 100%;
`;
